import MoviesComponent from "../Components/MoviesComponent"

const MoviesPage = () => {
    return (
        <div>
            <MoviesComponent />
        </div>
    );
}

export default MoviesPage;